import styled from 'styled-components';

export const GpdrWrapper = styled.div`
  background-color: ${props => props.color};
  display: flex;
  flex-direction: column;
  padding-bottom: 80px;
  min-height: 100%;

  iframe {
    height: calc(100vh - 150px);
    background-color: #fff;
    border: 0px;
  }
`;



// WEBPACK FOOTER //
// ./src/routes/Gpdr/components/styles.js